import { Colors } from '@auteco/theme'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  equalizerBoard: {
    display: 'flex',
    width: '100%',
    background: '#e9eaf3',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  equalizerActionBoard: {
    // display: 'grid',
    // gridTemplateColumns: 'repeat(2, 300px)',
    display: 'flex',
  },
  equalizer_item: {
    marginRight: '30px',
    display: 'flex',
    width: '200px',
    maxWidth: '13vw',
    flexDirection: 'column',
  },
  cardContainer: {
    padding: '20px',
  },
  grayCard: {
    padding: '4px',
    background: Colors.GRAY_BACKGROUND,
  },
  equalizerContainer: {
    margin: '20px',
  },
  title: {
    fontWeight: 'bold',
    color: Colors.DARK_BLUE,
  },
  titleEqualizaer: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: Colors.DARK_BLUE,
  },
})

export default useStyles
